import {
  BuildTestCard,
  GetTestCardDescription,
  ITestCardBuilder,
} from "./ITestCardBuilder";
import { TestType } from "@app/provider/testData/types";
import {
  EmpowerTestCard,
  HorizonTestCard,
  PanoramaTestCard,
  SGNIPTTestCard,
  VistaraTestCard,
} from "./connect";
import { TestCardBase } from "@app/provider/testData/testCard/TestCardBase";
import {
  ProsperaTestCard,
  RenasightTestCard,
} from "@app/provider/testData/testCard/organHealth";
import { LatitudeTestCard } from "@app/provider/testData/testCard/oncology";

export class TestCardBuilder implements ITestCardBuilder {
  protected readonly strategies: Record<TestType, TestCardBase | undefined> = {
    [TestType.ALTERA]: undefined,
    [TestType.ANORA]: undefined,
    [TestType.EMPOWER]: new EmpowerTestCard(),
    [TestType.HORIZON]: new HorizonTestCard(),
    [TestType.PANORAMA]: new PanoramaTestCard(),
    [TestType.PROSPERA]: new ProsperaTestCard(),
    [TestType.RENASIGHT]: new RenasightTestCard(),
    [TestType.SIGNATERA]: undefined,
    [TestType.SPECTRUM]: undefined,
    [TestType.VISTARA]: new VistaraTestCard(),
    [TestType.SINGLE_GENE_NIPT]: new SGNIPTTestCard(),
    [TestType.LATITUDE]: new LatitudeTestCard(),
    [TestType.DPYD]: undefined,
  };

  public buildTestCard: BuildTestCard = (testCard, intl) => {
    return this.strategies[testCard.testType]?.buildCard(testCard, intl);
  };

  public getTestCardDescription: GetTestCardDescription = (testCard, intl) => {
    return this.strategies[testCard.testType]?.getDescription(testCard, intl);
  };
}
